import React from "react";

import { DataAcquisitionTypeAndIcon } from "@src/components/molecules/data-acquisistion-type-and-icon/data-acquisistion-type-and-icon";

export const renderDataAcquisitionTypeWrapper = (child, type) => {
  let dataBitType;

  if (
    child.node_type === "VARIABLE" &&
    "attributes" in child &&
    type === "machine"
  ) {
    dataBitType = child.attributes.data_acquisition_type;
  }

  return (
    dataBitType && <DataAcquisitionTypeAndIcon typeOfDataBit={dataBitType} />
  );
};
